import { NumberComponent } from '../../../shared/NumberComponent';
import { ProgressArrow } from './ProgressArrow';

export const StatsCard = ({
  icon: Icon,
  title,
  previous,
  totalNumber,
}: {
  icon: React.ComponentType<any>;
  title: string;
  previous: number;
  totalNumber: number;
}) => {
  return (
    <div className="relative h-52 w-[270px] rounded-lg bg-base-100 px-4 pt-8">
      <div className="flex flex-row justify-between">
        <div className="flex flex-col gap-2">
          <p>{title}</p>
          <NumberComponent totalNumber={totalNumber} />
        </div>
        <Icon className="h-[48px] w-[48px] text-current" aria-label="Users" />
      </div>
      <div className="mt-2 flex flex-row items-center gap-2">
        <ProgressArrow previous={previous} totalNumber={totalNumber} />
      </div>
    </div>
  );
};
